var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('registrations.votingStats.pageTitle')}},[_c('VotingStats')],1)}
var staticRenderFns = []

export { render, staticRenderFns }